import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Row, Col, Typography, Button, Spin, message } from 'antd';
import { ApiOutlined, GlobalOutlined, RocketOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const SelectService = () => {
	const [loading, setLoading] = useState(false);
	const [services, setServices] = useState([]);
	const navigate = useNavigate();

	useEffect(() => {
		fetchServices();
	}, []);

	const fetchServices = async () => {
		setLoading(true);
		try {
			// Simulate API call or fetch actual services data
			const serviceData = [
				{
					id: 'bhashini',
					title: 'Bhashini API',
					description: 'Translate and process multilingual data using Bhashini.',
					icon: <GlobalOutlined style={{ fontSize: '2rem', color: '#1890ff' }} />,
					route: '/select-service/bhashini-service',
					features: ['Multi-language support', 'Real-time translation', 'Speech recognition']
				},
				{
					id: 'cirium',
					title: 'Cirium API',
					description: 'Fetch and manage flight data with Cirium services.',
					icon: <RocketOutlined style={{ fontSize: '2rem', color: '#52c41a' }} />,
					route: '/select-service/cirium-service',
					features: ['Flight tracking', 'Airport data', 'Schedule management']
				},
				{
                    id: 'dashboard',
                    title: 'Dashboard',
                    description: 'Analytics and monitoring dashboard.',
                    icon: <GlobalOutlined style={{ fontSize: '2rem', color: '#fa8c16' }} />,
                    route: '/select-service/dashboard-service',
                    features: ['Real-time analytics', 'Data visualization', 'Performance metrics']
                }
				
				
			];
			
			setServices(serviceData);
		} catch (error) {
			message.error('Error loading services');
			console.error('Error fetching services:', error);
		} finally {
			setLoading(false);
		}
	};

	const handleServiceSelect = (service) => {
		try {
			setLoading(true);
			// Add any pre-navigation logic here if needed
			navigate(service.route);
		} catch (error) {
			message.error('Error navigating to service');
			console.error('Navigation error:', error);
		} finally {
			setLoading(false);
		}
	};

	const renderServiceCard = (service) => (
		<Col xs={24} sm={12} lg={8} key={service.id}>
			<Card
				hoverable
				className="service-card"
				style={{
					height: '100%',
					borderRadius: '15px',
					boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
					transition: 'all 0.3s ease',
					border: '1px solid #f0f0f0'
				}}
				bodyStyle={{ 
					padding: '24px',
					textAlign: 'center',
					height: '100%',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'space-between'
				}}
				onClick={() => handleServiceSelect(service)}
			>
				<div>
					<div style={{ marginBottom: '16px' }}>
						{service.icon}
					</div>
					<Title level={3} style={{ marginBottom: '12px', color: '#262626' }}>
						{service.title}
					</Title>
					<Paragraph style={{ color: '#8c8c8c', marginBottom: '16px' }}>
						{service.description}
					</Paragraph>
					<div style={{ marginBottom: '20px' }}>
						{service.features.map((feature, index) => (
							<div key={index} style={{ 
								padding: '4px 8px',
								margin: '2px',
								backgroundColor: '#f6ffed',
								border: '1px solid #b7eb8f',
								borderRadius: '4px',
								fontSize: '12px',
								color: '#389e0d',
								display: 'inline-block'
							}}>
								{feature}
							</div>
						))}
					</div>
				</div>
				<Button 
					type="primary" 
					icon={<ApiOutlined />}
					style={{ width: '100%' }}
					loading={loading}
				>
					Get Started
				</Button>
			</Card>
		</Col>
	);

	return (
		<div style={{ 
			padding: '40px 24px',
			minHeight: '100vh',
			background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
		}}>
			<div style={{ maxWidth: '1200px', margin: '0 auto' }}>
				<div style={{ 
					textAlign: 'center', 
					marginBottom: '48px',
					background: 'white',
					padding: '40px',
					borderRadius: '20px',
					boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)'
				}}>
					<Title level={1} style={{ 
						marginBottom: '16px',
						background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
						WebkitBackgroundClip: 'text',
						WebkitTextFillColor: '#262626',
						fontSize: '2rem',
					}}>
						Welcome to Service Selection Page
					</Title>
					<Paragraph style={{ 
						fontSize: '18px',
						color: '#595959',
						maxWidth: '600px',
						margin: '0 auto'
					}}>
						Choose from our comprehensive suite of API services to proceed further. 
					</Paragraph>
				</div>

				<Spin spinning={loading}>
					<Row gutter={[24, 24]} justify="center">
						{services.map(service => renderServiceCard(service))}
					</Row>
				</Spin>

				{services.length === 0 && !loading && (
					<div style={{ textAlign: 'center', padding: '40px' }}>
						<Paragraph style={{ color: '#8c8c8c' }}>
							No services available at the moment. Please try again later.
						</Paragraph>
					</div>
				)}
			</div>
		</div>
	);
};

export default SelectService;